import { useState, useContext } from 'react'

import { Breadcrumbs, Backdrop, CircularProgress, Typography, Box } from '@mui/material'
import { Link } from 'react-router-dom'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

import { AppContext } from '/providers/app-context'
import Header from './header'
import Settings from '/components/settings'
import StyledPaper from './paper.jsx'
import config from '/providers/config'
import PopupShell from './editor/popup-shell'

const PageWrapper = ({ children, title, HelpText = EmptyHelp, heading, menu, isErrorPage = false }) => {

  const { client, processing, copyingEmail } = useContext(AppContext)
  const [showHelp, setShowHelp] = useState(false)
  const [showSettings, setShowSettings] = useState(false)

  const toggleHelp = () => setShowHelp(!showHelp)
  const toggleSettings = () => setShowSettings(!showSettings)

  const crumbs = window.location.pathname.split("/").filter(i => i !== "")

  const getLink = idx => {
    let link = ""
    for (let i = 0; i <= idx; i++) link += "/" + crumbs[i]
    return link
  }

  return (
    <div style={{ minWidth: "1024px", overflowX: "auto" }}>
      {!copyingEmail &&
        <Box sx={{color:"menubar.fg"}}>
          <Header title={title} toggleHelp={toggleHelp} toggleSettings={toggleSettings} isErrorPage={isErrorPage} />

          <PopupShell open={showHelp} onClose={toggleHelp} width={config.helpDrawerWidth} variant="solid">
            <div style={{ marginTop: 24, overflow: "auto", height: "100%" }}>
              <HelpText />
            </div>
          </PopupShell>

          <PopupShell open={showSettings} onClose={toggleSettings} width={config.settingsDrawerWidth} variant="solid">
            <div style={{ marginTop: 24, overflow: "auto", height: "100%" }}>
              <Settings />
            </div>
          </PopupShell>

          {client?.initialised &&
            <Box sx={{ position: "fixed", top: 63, left: 0, right: 0, zIndex: 100, width: "max(1024px, 100vw)", overflowX: "auto", paddingBottom: "50px" }} >
              <StyledPaper>
                <Breadcrumbs aria-label="breadcrumb" separator={<PlayArrowIcon fontSize="small" sx={{ whitespace: "nowrap", color:"menubar.crumbs" }}/>} sx={{color:"primary.main"}}>
                  <Link underline="hover" color="inherit" to="/"></Link>
                  <Link underline="hover" color="inherit" to="/">dashboard</Link>
                  {crumbs.map((c, i) => <Link key={i} underline="hover" color="inherit" to={getLink(i)}>{c.replace(/-/g, " ")}</Link>)}
                </Breadcrumbs>

                <Typography variant="h5" sx={{ p: 1, mb: 3 }}>{heading}</Typography>

                <Box sx={{ position: "fixed", bottom: 5, left: 0, right: 0 }}>
                  {menu}
                </Box>
              </StyledPaper>
            </Box>
          }
        </Box>
      }

      <Box sx={{ position: "fixed", top: client?.initialised ? (copyingEmail ? 0 : 185) : 64, bottom: 0, left: 0, right: 0, width: "max(1024px, 100vw)", overflowX: "hidden", zIndex: 101 }}>
        <Box sx={{ height: "100%" }}>
          {children}
        </Box>
      </Box>

      {processing &&
        <div className="flex h-screen">
          <div className="m-auto flex flex-row gap-10">
            <Backdrop open={true} sx={{ color: '#fff', zIndex: 99999 }}>
              <CircularProgress className='mr-20' /> Processing...
            </Backdrop>
          </div>
        </div>
      }
    </div>
  )
}

export default PageWrapper

// Default prevents errors if HelpText is undefined
// This occures for the loading screen
// Also seems to happen for other pages during early render. Not sure why?
const EmptyHelp = () => {
  return (
    <Typography variant='h5'>Help</Typography>
  )
}
